module.exports = __webpack_public_path__ + "img/product_107.e69b0d5.webp";